'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useState } from 'react';
import BrandBookFormActive from '@/components/BrandBookFormActive';
import BrandBookFormSend from '@/components/BrandBookFormSend';
import { BrandbookFormStatus } from '@/constants/form';
import css from './style.module.scss';
const BrandBookForm = () => {
  const $ = _c(11);
  const [formStatus, setFormStatus] = useState(BrandbookFormStatus.Disabled);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setFormStatus(BrandbookFormStatus.Active);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const setFormStatusToActive = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setFormStatus(BrandbookFormStatus.Disabled);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setFormStatusToDisabled = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setFormStatus(BrandbookFormStatus.Send);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setFormStatusToSend = t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className={css.title}>Free Q Brand Book example</p>;
    t4 = <p className={css.text}>Drop your email, and we'll fire over a brand book example to show what striking branding should look like.</p>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={css.textBlock}>{t3}{t4}<div className={css.buttonContainer}><button className={css.button} onClick={setFormStatusToActive}><Image width={222} height={61} alt="" src="/assets/images/brandQuiz/tape.png" className={css.tape} /><span className={css.buttonText}>Get brand book</span></button></div></div>;
    t6 = <Image height={940} width={720} alt="" src="/assets/images/brand-book/mannequin.png" className={css.mannequin} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== formStatus) {
    t7 = formStatus === BrandbookFormStatus.Active ? <BrandBookFormActive onClose={setFormStatusToDisabled} onSend={setFormStatusToSend} /> : formStatus === BrandbookFormStatus.Send ? <BrandBookFormSend onClose={setFormStatusToDisabled} /> : null;
    $[7] = formStatus;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <div className={css.container}>{t5}{t6}{t7}</div>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};
export default BrandBookForm;